module.exports = {
    APPLICATION_ID: "BJRCM8UbaoAgNriEisN9OVbL6zjURgAcESsvBh47",
    JAVASCRIPT_KEY: "zi9aPGs77R0bWjzDvmWeH1evda806UivyW8wGQAJ",
    SERVER_URL: "https://parseapi.back4app.com",
};
